import { SearchIcon } from 'assets/icons';

export interface ISearchInputProps {
  name: string;
  placeholder: string;
  onChange: any;
  value: any;
}
export const SearchInput = ({
  name,
  placeholder,
  onChange,
  value,
}: ISearchInputProps) => {
  return (
    <div className="relative flex w-full flex-wrap items-stretch">
      <span className="z-10 h-full leading-snug font-normal absolute text-center text-gray-400 bg-transparent rounded text-base items-center justify-center w-8 left-0 pl-3 py-4">
        <span>{<SearchIcon />}</span>
      </span>
      <input
        type="text"
        onChange={onChange}
        name={name}
        value={value}
        placeholder={placeholder}
        className=" h-12 px-4  pl-10 rounded border border-gray-100 focus:outline-none focus:ring-1 focus:ring-gray-light focus:border-transparent placeholder-gray-400 text-gray-600 text-sm outline-none w-full"
      />
    </div>
  );
};
